import * as Yup from 'yup';

const MAX_FILE_SIZE = 5242880; //5mb
const validFileExtensions = { file: ['pdf'] };

function isValidFileType(fileName, fileType) {
  return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
}

Yup.addMethod(Yup.string, "validaCpf", function (errorMessage) {
  return this.test(`test-cpf`, errorMessage, function (value) {
    const { path, createError } = this;

    return (
      validaCPF(value) ||
      createError({ path, message: errorMessage })
    );
  });
});

function validaCPF(cpf) {
  var Soma = 0
  var Resto
  var i = null;

  var strCPF = String(cpf).replace(/[^\d]/g, '')
  
  if (strCPF.length !== 11)
     return false
  
  if ([
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
    ].indexOf(strCPF) !== -1)
    return false

  for (i=1; i<=9; i++)
    Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);

  Resto = (Soma * 10) % 11

  if ((Resto == 10) || (Resto == 11)) 
    Resto = 0

  if (Resto != parseInt(strCPF.substring(9, 10)) )
    return false

  Soma = 0

  for (i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)

  Resto = (Soma * 10) % 11

  if ((Resto == 10) || (Resto == 11)) 
    Resto = 0

  if (Resto != parseInt(strCPF.substring(10, 11) ) )
    return false

  return true
}

export const contactSchema = Yup.object().shape({
  name: Yup.string().required().label("Name"),
  email: Yup.string().required().email().label("Email"),
  sub: Yup.string().required().label("Subject"),
  msg: Yup.string().required().min(20).label("Message"),
});

export const redacaoSchema = Yup.object().shape({
  tema: Yup.string().required('Campo obrigatório').label("Tema"),
  plano: Yup.string().required('Campo obrigatório'),
  file: Yup.mixed()
        .required("Obrigatório")
        .test("is-valid-type", "Formato inválido, envie em PDF.",
          value => isValidFileType(value && value.name.toLowerCase(), "file"))
        .test("is-valid-size", "O tamanho máximo para o arquivo deve ser 5mb.",
          value => value && value.size <= MAX_FILE_SIZE)
});

export const newsletterSchema = Yup.object().shape({
  email: Yup.string().required('Campo obrigatório').email().label("Email"),
});

export const loginSchema = Yup.object().shape({
  email: Yup.string().required('Campo obrigatório').email('Por favor, insira um e-mail válido').label("Email"),
  password: Yup.string().required('Campo obrigatório').min(6, 'Mínimo 6 caracteres').label("Password"),
});

export const recuperarASenhaSchema = Yup.object().shape({
  email: Yup.string().required('Campo obrigatório').email('E-mail inválido').label("Email")
});

export const meuPerfilSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório').label("Name"),
  email: Yup.string().required('Campo obrigatório').email('E-mail inválido').label("Email"),
  cpf: Yup.string().required('Campo obrigatório').min(11, 'Mínimo 11 caracteres').label("CPF"),
  telefone: Yup.string().required('Campo obrigatório')
});

export const registerSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório').label("Name"),
  email: Yup.string().required('Campo obrigatório').email('E-mail inválido').label("Email"),
  magree: Yup.boolean().oneOf([true], 'Obrigatório'),
  confirmeEmail: Yup.string().required('Campo obrigatório').email('E-mail inválido').oneOf([Yup.ref('email'), null], 'Os e-mails não conferem'),
  password: Yup.string().required('Campo obrigatório').min(6, 'Mínimo 6 caracteres').label("Password"),
  passwordConfirmation: Yup.string().required('Campo obrigatório').min(6, 'Mínimo 6 caracteres').oneOf([Yup.ref('password'), null], 'As senhas não conferem')
});

export const assineAgoraSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório').label("Nome"),
  email: Yup.string().required('Campo obrigatório').email('E-mail inválido').label("Email"),
  cpf: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório').validaCpf("CPF inválido"),
  telefone: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório'),
  cep: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório'),
  endereco: Yup.string().required('Campo obrigatório'),
  bairro: Yup.string().required('Campo obrigatório'),
  cidade: Yup.string().required('Campo obrigatório'),
  estado: Yup.string().required('Campo obrigatório'),
  numero: Yup.string().required('Campo obrigatório'),
  formaPagamento: Yup.string().required('Campo obrigatório'),
  nome_dono_cartao: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().required('Campo obrigatório')
  }),
  numero_cartao: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório')
  }),
  mes: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().matches(/^\d+$/, 'Somente números').min(2, 'Mínimo 2 caracteres').max(2, 'Máximo 2 caracteres').required('Campo obrigatório')
  }),
  ano: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().matches(/^\d+$/, 'Somente números').min(2, 'Mínimo 2 caracteres').max(2, 'Máximo 2 caracteres').required('Campo obrigatório')
  }),
  parcelas: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().required('Campo obrigatório')
  }),
  cvv: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().matches(/^\d+$/, 'Somente números').min(3, 'Mínimo 3 caracteres').max(4, 'Máximo 4 caracteres').required('Campo obrigatório')
  })
});

export const assineAgoraSemCadastroSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório').label("Nome"),
  email: Yup.string().required('Campo obrigatório').email('E-mail inválido').label("Email"),
  confirmeEmail: Yup.string().oneOf([Yup.ref('email'), null], 'Os e-mails não conferem'),
  password: Yup.string().required('Campo obrigatório').min(6, 'Mínimo 6 caracteres').label("Password"),
  passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'As senhas não conferem'),
  cpf: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório').validaCpf("CPF inválido"),
  telefone: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório'),
  cep: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório'),
  endereco: Yup.string().required('Campo obrigatório'),
  bairro: Yup.string().required('Campo obrigatório'),
  cidade: Yup.string().required('Campo obrigatório'),
  estado: Yup.string().required('Campo obrigatório'),
  numero: Yup.string().required('Campo obrigatório'),
  formaPagamento: Yup.string().required('Campo obrigatório'),
  nome_dono_cartao: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().required('Campo obrigatório')
  }),
  numero_cartao: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().matches(/^\d+$/, 'Somente números').required('Campo obrigatório')
  }),
  mes: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().required('Campo obrigatório')
  }),
  ano: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().required('Campo obrigatório')
  }),
  parcelas: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().required('Campo obrigatório')
  }),
  cvv: Yup.string().ensure().when('formaPagamento', {
    is: (formaPagamento) => formaPagamento == 'credit_card',
    then: Yup.string().matches(/^\d+$/, 'Somente números').min(3, 'Mínimo 3 caracteres').max(4, 'Máximo 4 caracteres').required('Campo obrigatório')
  })
});

export const blogSchema = Yup.object().shape({
  name: Yup.string().required().label("Name"),
  email: Yup.string().required().email().label("Email"),
  subject: Yup.string().required().min(10).label("Subject"),
  msg: Yup.string().required().min(20).label("Message"),
});